import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/services/auth.service';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.css']
})
export class AdminLayoutComponent {
  mainPath = "" // قراءة القيمة من environment
  upFooterLogoPicSrc = "" // قراءة القيمة من environment
  enviroment=environment;

  isProduction=environment.production;
  downFooterLogoPicSrc = "" // قراءة القيمة من environment
  SectionId = "" // قراءة القيمة من environment

  constructor(private authService:AuthService,) {
    this.mainPath= environment.MainPath;
    this.upFooterLogoPicSrc= environment.UpFooterLogoPicSrc;
    this.checkRoles();


    this.mainPath= environment.MainPath;
    this.SectionId= environment.SectionId;
    this.downFooterLogoPicSrc= environment.DownFooterLogoPicSrc;
    this.upFooterLogoPicSrc= environment.UpFooterLogoPicSrc;
  }

  showFinance=false;
  showEtewiSection =false;
  showExmp=false;
  showCommitteesAndDisabits=false;

  getYear():string{
    return new Date().getFullYear().toString();
  }

  logout(){
    this.authService.removeToken();
    location.href="/";
  }

  checkRoles(){
    var roles=this.authService.getRole();

    if(roles?.includes('PROVIDER') && roles?.includes('FO_MOIN')){
      this.showFinance=true;
    }else if(roles?.includes('HDRDA_MOIN')){
      this.showEtewiSection=true;
    }
    else if(roles?.includes('PROVIDER') && roles?.includes('HEID_MOIN')){
      this.showExmp=true;
    
    }else if(roles?.includes('PROVIDER') && roles?.includes('HEID_MOIN')){
      this.showExmp=true;
    }
    else if(roles?.includes('PROVIDER') && roles?.includes('DCEPA_HCD')){
      this.showCommitteesAndDisabits=true;
    }

  }

}
